export default {
  datatable: {
    init: false,
    loading: false,
    headers: [
      {
        text: 'Код конфига',
        value: 'configCode',
      },
      {
        text: 'Код шаблона',
        value: 'templateCode',
      },
      {
        text: 'Тэги',
        value: 'tags',
      },
      {
        text: 'Действия',
        value: 'actions',
      },
    ],
    items: [],
    params: {
      filterString: null,
      tags: [],
      page: 1,
      itemsPerPage: 10,
      totalRecords: null,
    },
  },
  save: {
    loading: false,
  },
  templates: {
    loading: false,
    items: [],
  },
  tags: {
    loading: false,
    items: [],
  },
  createConfig: {
    loading: false,
    form: {
      templateCode: null,
      code: null,
      tags: [],
      sets: [],
    },
  },
  readConfigById: {
    loading: false,
  },
  editConfig: {
    loading: false,
    updateLoading: false,
    templateCode: null,
    id: null,
    form: {
      code: null,
      tags: [],
      sets: [],
    },
  },
  removeConfigById: {
    loading: false,
  },
};
